export default __webpack_public_path__ + "static/media/6.14.84172383.mp3";